//import styles from "./About.module.sass";
//import cn from "classnames";
//import { axiosInstance } from "../../utils/API";
//import { PopUpAlert } from "../../controller/utils";
//import { useEffect, useState } from "react";
//import Popular from "../Home/Popular";
//import RecentSold from "../Home/RecentSold";
//            <RecentSold color="#f5f5f5" textColor="#000000"></RecentSold>
import AboutRealSplit from "./AboutRealSplit";
import { useNavigate } from "react-router-dom";

const About = () => {

    //const [about, setAbout] = useState(null);
    const navigate = useNavigate()
    // useEffect(() => {
    //   axiosInstance.get('/webcontent?key=about_us').then((res) => {
    //     setAbout(res?.data?.result[0]);
    //   }).catch((err) => {
    //     PopUpAlert("Alert", err?.data?.response?.error ? err?.data?.response?.error : err.message, "error")
    //   })
    // }, []);
    const redirectNft = () => {
        navigate('/search/all')
    }

    return (
        
        <main className = 'item-main edit-profile about'>
            <section
                //className={styles.aboutsection}
                className = 'form property-information'
                //className = 'form'
                style = {{
                    paddingTop: "0px"
                    , paddingBottom: "80px"
                }}
                >
                <div
                    className = { 'max-width' }
                    style = {{ paddingLeft: '0px', paddingRight: '0px' }}
                    >
                    <div
                        //className = 'flex-container'
                        className = { 'property-information' }
                        //style = {{ textAlign: "left" }}
                        >
                        
                        <AboutRealSplit />
                        
                    </div>
                </div>
            </section>

        </main>
        
    );
};

export default About;
